import { useMemo } from "react";
import DataTable from "react-data-table-component";
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from "@albo-ui/core";
import { Box, IconButton, Tooltip } from '@mui/material';
import { customStyles } from "../../../util/TableStyles";
import { noDataComponent } from "../../../util/DataObject";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import DeleteIcon from '@mui/icons-material/Delete';

export type CRMGroupDetailProps = {
    open: boolean;
    data: Object;
    onClose: () => void;
    onDeleteCompany: (data: any) => void;
};

export const CRMGroupDetail = ({ data, open, onClose, onDeleteCompany }: CRMGroupDetailProps) => {
    customStyles.table.style["justifyContent"] = data && data["partner_list"].length === 0 ? "center" : "normal"

    const columns = useMemo(() => {
        const columns = [
            { selector: (row) => row["company_name"], name: "Empresas Asociadas", wrap: true, sortable: true },
            { cell: (item) => {
                return (
                    <Tooltip title='Eliminar'>
                        <IconButton onClick={onDeleteCompany.bind(this, item)}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                )},
                name: "Acciones", sortable: true, width: "30%", center: true
            }
        ];

        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <Dialog onClose={onClose} open={open} style={{ minWidth: 600, maxHeight: 500 }}>
            {data &&
                <DialogTitle>
                    <Box display={"flex"} alignItems={"center"}>
                        <BusinessCenterIcon sx={{ marginRight: 2 }} color="primary" fontSize="large"/>
                        <Typography variant="h2" style={{ fontSize: "1.2rem" }}>{data["group_name"]}</Typography>
                    </Box>
                    <Typography variant="small" style={{fontSize: "0.8rem", fontStyle: "italic" }}>Total de empresas: {data["partner_list"]?.length} </Typography>
                </DialogTitle>
            }
            <DialogContent>
                <DataTable
                    data={data && data["partner_list"]}
                    columns={columns}
                    customStyles={customStyles}
                    noDataComponent={noDataComponent}
                    dense
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} size="normal">Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
};
